import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/base.css";
import { App } from "./App";

// The `data-theme` attribute lives on <html> so :root selector matches
// even before React mounts. Persisted user preference is read here on
// initial load so the first paint is theme-correct; otherwise dark is
// the default (per web-build-spec Correction 2). <ThemeToggle> keeps
// it in sync afterwards.
try {
  if (localStorage.getItem("aster.theme") === "light") {
    document.documentElement.setAttribute("data-theme", "light");
  }
} catch {
  // Storage may be blocked (embedded contexts). Non-fatal.
}

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Missing #root element in index.html");
}
createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
